export enum GtmEventEnum {
  // Group A: Fire-and-forget (alongside PostHog captures)
  SubscriptionCheckoutStarted = 'subscription_checkout_started',
  SubscriptionStarted = 'subscription_started',
  PlanUpgraded = 'plan_upgraded',
  ArticleCreated = 'article_created',
  ActionCreated = 'action_created',
  PreviewConversationStarted = 'preview_conversation_started',
  WidgetSnippetCopied = 'widget_snippet_copied',

  // Group B: Session events (once per browser session)
  AppSessionStart = 'app_session_start',
  LongTimeNoSee = 'long_time_no_see',

  // Group C: Milestone events (once ever per scenario)
  FirstLiveConversation = 'first_live_conversation',
}
